export const parseSlug = url =>
  url.replace(/^(\/|(com\.nbx\.exchange:(\/\/)?)?((https:\/\/)?app\.nbx\.com\/)?)/, '/');
